export enum AlarmStatus {
	disarm = 'Disarmed',
	arm = 'Armed',
	overriden = 'Overridden',
}

export const disarmedAlarmText = $localize`:@@ajaxStatusText-disarmedAlarm:Disarmed Alarm`;
export const armedAlarmText = $localize`:@@ajaxStatusText-armedAlarm:Armed Alarm`;
export const alarmOverrideText = $localize`:@@ajaxStatusText-alarmOverride:Alarm Override`;
